import { Editor } from '@tiptap/react';
import React from 'react';

import { TagOptions } from '@/ui/Editor/extensions/Tag/types';

interface UseTagExtensionProps {
	editor: Editor | null;
	tag?: false | TagOptions;
}

const useTagExtension = (props: UseTagExtensionProps) => {
	const { editor, tag = false } = props;

	const tagEnabled = tag !== false;
	const tagList = (tagEnabled && tag?.availableTags) || [];

	const handleDrop = React.useCallback(
		(event: React.DragEvent) => {
			event.preventDefault();

			if (tagEnabled) {
				const tag = event.dataTransfer.getData('tag');

				if (tag && editor) {
					const dropPosition = editor.view.posAtCoords({
						left: event.clientX,
						top: event.clientY,
					});

					if (dropPosition) {
						const { pos } = dropPosition;
						editor.chain().focus().setTextSelection(pos).setTag(tag).run();
					} else {
						editor.chain().focus().setTag(tag).run();
					}
				}
			}
		},
		[editor, tagEnabled]
	);

	React.useEffect(() => {
		if (tagEnabled) {
			editor?.commands?.setAvailableTags?.(tagList);
		}
	}, [tagList]);

	return {
		handleDrop,
		tagList,
		tagEnabled,
	};
};

export { useTagExtension };
